const list = [{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	}
]
const apartment = [{
		img: require('@/assets/image/housing/y-1.png'),
		name: "咖啡书社"
	},
	{
		img: require('@/assets/image/housing/y-2.png'),
		name: "vr电影院"
	},
	{
		img: require('@/assets/image/housing/y-3.png'),
		name: "烘培轻食"
	},
	{
		img: require('@/assets/image/housing/y-4.png'),
		name: "精品超市"
	},
	{
		img: require('@/assets/image/housing/y-5.png'),
		name: "社区医院"
	},
	{
		img: require('@/assets/image/housing/y-6.png'),
		name: "数码文具"
	},
	{
		img: require('@/assets/image/housing/y-7.png'),
		name: "主题餐厅"
	},
	{
		img: require('@/assets/image/housing/y-8.png'),
		name: "美发美甲"
	},
	{
		img: require('@/assets/image/housing/y-9.png'),
		name: "健身中心"
	},
	{
		img: require('@/assets/image/housing/y-10.png'),
		name: "干洗靓鞋"
	},
	{
		img: require('@/assets/image/housing/y-11.png'),
		name: "萌宠用品"
	},
]

const room = [{
		img: require('@/assets/image/housing/l-4.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	{
		img: require('@/assets/image/housing/l-2.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	{
		img: require('@/assets/image/housing/l-3.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	{
		img: require('@/assets/image/housing/l-3.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
]


const matching = [{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	}
]

const list1 = [{
		img: require('@/assets/image/housing/l-1.png'),
		name: "柳影人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.306671,
			lat: 43.946118
		},
	},
	{
		img: require('@/assets/image/housing/l-2.png'),
		name: "基隆人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区基隆北街1823",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.288395,
			lat: 43.947048,
		},
	},
	{
		img: require('@/assets/image/housing/l-3.png'),
		name: "富丰人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.306671,
			lat: 43.946118
		},
	},
	{
		img: require('@/assets/image/housing/l-4.png'),
		name: "珍珠湖人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市绿园区基隆中街两侧",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.262573,
			lat: 43.919844,
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	},
	{
		img: require('@/assets/image/housing/l-1.png'),
		name: "博众新城人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.329914,
			lat: 43.915177
		},
	}
]

export {
	list,
	apartment,
	room,
	matching,
	list1
}
